<template>
    <Sheet v-loading="loading.actions['config']">
        <h2>{{routeTitle}}</h2>
        <el-tabs type="border-card"
            v-model="activeName"
            @tab-click="handleClick">
            <el-tab-pane name="p1">
                <span slot="label"><i class="el-icon-setting"></i> 系統參數設定</span>           
                <el-row>
                    <el-col :xl="10" :lg="12" :md="18" :sm="24" :xs="24">
                        <div style="background-color: azure;width: 100%; padding: 10px 5px">
                            <el-form
                                    :model="model"
                                    :rules="rules"
                                    label-width="140px"
                                    ref="form"
                            >
                                <el-form-item
                                        prop="homePageId"
                                        label="預設首頁"
                                >
                                    <el-select
                                            v-model="model.homePageId"
                                            placeholder="請選擇首頁選單"
                                    >
                                        <el-option
                                                v-for="l in menuOptions"
                                                :key="l.key"
                                                :value="l.value"
                                                :label="l.label"
                                        ></el-option>
                                    </el-select>
                                </el-form-item>
                                <!-- <el-form-item
                                        prop="adminPassword"
                                        label="管理者密碼"
                                >
                                    <el-input
                                            v-model="model.text1"
                                            placeholder="請輸入管理者密碼"
                                            show-password
                                    ></el-input>
                                </el-form-item> -->
                                <el-form-item
                                        prop="sysTitle"
                                        label="網頁抬頭">
                                    <el-input
                                            v-model="model.sysTitle"
                                            placeholder="請輸入網頁抬頭"></el-input>
                                </el-form-item>
                                <el-form-item
                                        prop="eMail"
                                        label="系統管理員信箱">
                                    <el-input
                                            v-model="model.eMail"
                                            placeholder="請輸入系統管理員信箱"></el-input><font size="-1" color="#003399">
                                    <b>說明：</b>輸入多位收件人信箱時，以分號“；”分隔</font>
                                </el-form-item>
                                <el-form-item
                                        prop="idleInterval"
                                        style="padding: 0 0 0 0.5em;"
                                        label="畫面閒置檢查時間">
                                    <el-input-number :min="0" :max="180" label="分鐘" style="width:10em"
                                        v-model="model.idleInterval"
                                        placeholder="請輸入畫面閒置檢查時間"/><span style="margin: 1em;">分鐘</span>
                                </el-form-item>
                                <el-form-item
                                        prop="idleMessage"
                                        label="自動登出顯示訊息">
                                    <el-input
                                            v-model="model.idleMessage"
                                            placeholder="請輸入自動登出顯示訊息"></el-input>
                                </el-form-item>
                                <el-form-item
                                        prop="bgColor"
                                        label="背景顏色">
                                    <el-color-picker v-model="model.bgColor"></el-color-picker>
                                </el-form-item>
                                <el-form-item
                                        prop="debugMode"
                                        label="開發模式"
                                >
                                    <el-checkbox
                                            v-model="model.debugMode"
                                    ></el-checkbox>
                                </el-form-item>
                                <el-form-item
                                        prop="shnm"
                                        label="頁尾文字一">
                                    <el-input
                                            v-model="model.shnm"
                                            placeholder="請輸入頁尾文字一"></el-input>
                                </el-form-item>
                                <el-form-item
                                        prop="shAdd"
                                        label="頁尾文字二">
                                    <el-input
                                            v-model="model.shAdd"
                                            placeholder="請輸入頁尾文字二"></el-input>
                                </el-form-item>
                                <el-form-item
                                        prop="shFax"
                                        label="頁尾文字三">
                                    <el-input
                                            v-model="model.shFax"
                                            placeholder="請輸入頁尾文字三"></el-input>
                                </el-form-item>
                                <el-form-item
                                        prop="logDays"
                                        style="padding: 0 0 0 0.5em;"
                                        label="日誌保存時間">
                                    <el-input-number :min="0" :max="255" label="天" style="width:10em"
                                        v-model="model.logDays"
                                        placeholder="請輸入日誌保存時間"/><span style="margin: 1em;">天</span>
                                </el-form-item>
                            </el-form>
                            <div style="width: 100%; text-align: right; background-color: azure; padding: 10px 0px">
                                <el-button
                                        @click="onSubmit"
                                        size="mini"
                                        style="margin-right: 5px;"
                                        type="primary"
                                >
                                    更新設定
                                </el-button>
                            </div>
                        </div>

                    </el-col>
                </el-row>
            </el-tab-pane>
            <el-tab-pane name="p2">
                <span slot="label"><i class="el-icon-document"></i> 一般參數設定</span>
                <el-row :gutter="24">
                    <el-col :span="6">
                        <table class="ncut-table-menu-striped ncut-table-menu" bgcolor="#FFFFFF" style="width:100%">
                            <thead class="ncut-thead-menu">
                                <tr>
                                    <th style="width: 1.5em;"></th>
                                    <th>代碼</th>
                                </tr>
                            </thead>
                            <tbody class="ncut-tbody-menu"
                                v-if="null != codeList">
                                <tr v-for="(item, index) in codeList" :key="'S1'+item.id" :index="item.id" :name="item.id"
                                    @click="rowClick(index, item)"
                                    v-bind:class="{ selected: index == selectedRowIndex }">
                                    <td><i class="el-icon-search"></i></td>
                                    <td style="text-align: center;">{{item.id}}</td>
                                </tr>
                                <tr v-if="null == codeList">
                                    <td colspan="2">無</td>
                                </tr>
                            </tbody>
                        </table>
                    </el-col>
                    <el-col :xl="18" :lg="18" :md="18" :sm="24" :xs="24">
                        <template 
                            v-if="-1 < selectedRowIndex">
                            <span class="glyphicon glyphicon-pencil" style="margin-right: 4px;"
                                @click="newType()">
                                <a href="#"><i class="el-icon-circle-plus-outline"/>新增參數值</a>
                            </span>
                            <table class="ncut-table-menu-striped ncut-table-menu" bgcolor="#FFFFFF" style="width:100%">
                                <thead class="ncut-thead-menu">
                                    <tr>
                                        <th style="width: 4em;">序號</th>
                                        <th style="width: 8em;">參數代碼</th>
                                        <th>參數值</th>
                                        <th>操作</th>
                                    </tr>
                                </thead>
                                <tbody class="ncut-tbody-menu"
                                    v-if="null != codeList">
                                    <tr v-for="(data, index) in codeList[selectedRowIndex].data" :key="'S2'+data.codeNo" :index="data.id" :name="data.id"
                                        v-bind:class="{ selected: index == selectedRowIndex }">
                                        <td style="text-align: center;">{{index+1}}</td>
                                        <td>
                                            <span v-if="data.status!='A'">{{data.codeNo}}</span>                                     
                                            <el-input
                                                v-model="data.codeNo"
                                                placeholder="請輸入代碼(獨一鍵值)"
                                                @change="changeFlag=true;"
                                                v-else />
                                        </td>
                                        <td>                                            
                                            <el-input
                                                v-model="data.codeName"
                                                placeholder="請輸入參數值"
                                                @change="data.status=(data.status=='A'?data.status: 'C'); changeFlag=true;"/>
                                        </td>
                                        <td>
                                            <el-radio-group placeholder="請選擇" size="small"
                                                v-model="data.isDelete"
                                                @change="data.status=(data.status=='A'?data.status: 'C'); changeFlag=true;">
                                                <el-radio-button key="O1" :label="false">預設</el-radio-button>
                                                <el-radio-button key="O2" :label="true">刪除</el-radio-button>
                                            </el-radio-group>  
                                        </td>
                                    </tr>
                                    <tr v-if="null == codeList">
                                        <td colspan="4">無</td>
                                    </tr>
                                </tbody>
                            </table>
                            <div style="width: 100%; text-align: right; background-color: azure; padding: 10px 0px">
                                <el-button
                                    @click="updateSet"
                                    :disabled="!changeFlag"
                                    size="mini"
                                    style="margin-right: 5px;"
                                    type="primary">
                                    更新設定
                                </el-button>
                            </div>
                        </template>
                    </el-col>
                </el-row>
            </el-tab-pane>
            <el-tab-pane name="p3">   
                <span slot="label"><i class="el-icon-document"></i> 預設參數拷貝</span>
                <el-row :gutter="24">
                    <el-col :span="8">
                        <table class="ncut-table-menu-striped ncut-table-menu" bgcolor="#FFFFFF" style="width:100%">
                            <thead class="ncut-thead-menu">
                                <tr>
                                    <th style="width: 1.5em;"></th>
                                    <th style="width: 4em;">
                                        代碼
                                    </th>
                                    <th>
                                        狀態
                                    </th>
                                </tr>
                            </thead>
                            <tbody class="ncut-tbody-menu"
                                v-if="null != codeList">
                                <tr v-for="(item, index) in codeList" :key="'C1'+item.id" :index="item.id" :name="item.id"
                                    @click="rowClick(index, item)"
                                    v-bind:class="{ selected: index == selectedRowIndex }">
                                <td><i class="el-icon-search"></i></td>
                                <td style="text-align: center;">{{item.id}}</td>
                                <td style="text-align: center;">
                                    <el-radio-group placeholder="請選擇" size="small"
                                        v-model="item.status"
                                        @change="changeFlag=true"
                                        :disabled="item.status==1">
                                        <el-radio-button key="O1" :label="0" v-if="item.status!=1">未設定</el-radio-button>
                                        <el-radio-button key="O2" :label="2" v-if="item.status!=1">已選擇</el-radio-button>
                                        <el-radio-button key="O2" :label="1" v-if="item.status==1">已設定</el-radio-button>
                                    </el-radio-group>  
                                </td>
                                </tr>
                                <tr v-if="null == codeList">
                                    <td colspan="3">無</td>
                                </tr>
                            </tbody>
                        </table>
                        <div style="width: 100%; text-align: right; background-color: azure; padding: 10px 0px">
                            <el-button
                                @click="save"
                                :disabled="!changeFlag"
                                size="mini"
                                style="margin-right: 5px;"
                                type="primary">
                                更新設定
                            </el-button>
                        </div>
                    </el-col>
                    <el-col :xl="16" :lg="16" :md="16" :sm="24" :xs="24">
                        <template 
                            v-if="-1 < selectedRowIndex">
                            <table class="ncut-table-menu-striped ncut-table-menu" bgcolor="#FFFFFF" style="width:100%">
                                <thead class="ncut-thead-menu">
                                    <tr>
                                        <th style="width: 4em;">序號</th>
                                        <th style="width: 8em;">
                                            參數代碼
                                        </th>
                                        <th>
                                            參數值
                                        </th>
                                    </tr>
                                </thead>
                                <tbody class="ncut-tbody-menu"
                                    v-if="null != codeList">
                                    <tr v-for="(data, index) in codeList[selectedRowIndex].data" :key="'C2'+data.codeNo" :index="data.id" :name="data.id"
                                        v-bind:class="{ selected: index == selectedRowIndex }">
                                        <td style="text-align: center;">{{index+1}}</td>
                                        <td>{{data.codeNo}}</td>
                                        <td>{{data.codeName}}</td>
                                    </tr>
                                    <tr v-if="null == codeList">
                                        <td colspan="3">無</td>
                                    </tr>
                                </tbody>
                            </table>
                        </template>
                    </el-col>
                </el-row>
            </el-tab-pane>
        </el-tabs>    
    </Sheet>
</template>

<script>
    import {mapActions, mapState} from 'vuex';
    import routeTitleMixin from './routeTitleMixin';
    import nodesMixin from './nodesMixin';
    import moment from 'moment';
    import {join} from '../utilities';

    export default {
        name: 'SystemConfigManage',
        mixins: [routeTitleMixin, nodesMixin],
        data: () => ({
            activeName: 'p1',
            changeFlag: false,
            selectedRowIndex: -1,
            model: {
                homePageId: ''
            },
            rules:{
                homePageId: [
                    {required: true, message: '請選擇預設首頁選單'}
                ],
                // adminPassword: [
                //     {required: true, message: '請輸入管理者密碼', trigger: ['blur', 'change']},
                //     {min: 8, message: '長度至少為8碼', trigger: ['blur', 'change']},
                // ],
                sysTitle: [
                    {required: true, message: '請輸入網頁抬頭', trigger: ['blur', 'change']}
                ],
                shnm: [
                    {required: false, message: '請輸入學校名稱', trigger: ['blur', 'change']}
                ],
                shAdd: [
                    {required: false, message: '請輸入學校地址', trigger: ['blur', 'change']}
                ],
                shFax: [
                    {required: false, message: '請輸入聯絡資訊', trigger: ['blur', 'change']}
                ],
                eMail: [
                    {required: true, message: '請輸入系統管理員信箱', trigger: ['blur', 'change']}
                ],
                bgColor: [
                    {required: true, message: '請輸入背景顏色', trigger: ['blur', 'change']}
                ],
                idleInterval: [
                    {required: true, message: '請輸入畫面閒置檢查時間', trigger: ['blur', 'change']}
                ],
                idleMessage: [
                    {required: true, message: '請輸入自動登出顯示訊息', trigger: ['blur', 'change']}
                ],
                logDays: [
                    {required: true, message: '請輸入日誌保存時間', trigger: ['blur', 'change']}
                ]
            }
        }),
        computed: {
            ...mapState(['loading']),
            ...mapState('config', ['config']),
            ...mapState('menu', ['menus']),
            ...mapState('codeDt', ['codeList']),

            menuOptions(){
                const opts = join(this.leave,
                    this.menus.filter(f =>
                        !f.isAuth
                        && !f.isHidden
                        && (f.always || moment().isBetween(f.range[0], f.range[1], '[]'))
                    ), l => l.id,
                    r => r.id, (_, r) => ({
                        value: r.menuId,
                        label: r.title,
                        key: r.id
                    }));

                return opts;
            }
        },

        methods: {
            ...mapActions('config', {
                getConfig: 'getConfigAction',
                update: 'updateConfigAction',
            }),
            ...mapActions('menu', {
                getMenus: 'getMenusAction',
            }),
            ...mapActions('codeDt', {
                getCodeAll: 'getCodeAll',
                copyCodeSet: 'copyCodeSet',
                getAllSet: 'getAllSet',
                updateCode: 'update',
            }),

            handleClick (tab, event) {
                var page = parseInt(tab.index);
                if (1 == page) {
                    this.changeFlag = false;
                    this.getAllSet();
                } else if (2 == page) {
                    this.changeFlag = false;
                    this.getCodeAll();
                }
            },

            async onSubmit(){
                const current = this.$refs['form'];
                current.validate(async valid => {
                    if (valid) {
                        const {success} = await this.update({
                            ...this.model
                        });

                        if (success) {
                            this.$message({
                                type: 'success',
                                message: '異動成功'
                            });
                        } else {
                            this.$message({
                                type: 'danger',
                                message: '操作失敗，請重試一次'
                            });
                        }
                        this.getConfig();
                    } else {
                        this.$message({
                            type: 'warning',
                            message: '驗證失敗，請檢查*欄位'
                        });
                    }
                });
            },
            rowClick(index, item) { 
                this.selectedRowIndex = index; 
            },
            isNull(data) {
            var ret = ((data != null) && (data != undefined) && (data != "null") ? false : true);
            return ret;
            },
            isEmpty (data) {
                return ((data != null) && (data != undefined) && (data.length > 0) ? false : true);
            },
            size(obj) {
                var size = 0, key;
                for (key in obj) {
                    if (obj.hasOwnProperty(key)) size++;
                }
                return size;
            },
            checkSaveData () {
                let ret = null;
                let cLen = this.size(this.codeList);
                for(var i=0; i < cLen; i++ ){
                    if (this.codeList[i].status == 2) {
                        if (null == ret) {
                            ret = [this.codeList[i].id];
                        } else {
                            ret.push(this.codeList[i].id)
                        }
                    }
                }

                return ret;
            },
            async save() {
                let tData = this.checkSaveData();
                if (!this.isEmpty(tData)) {
                    const {success} = await this.copyCodeSet(tData);

                    if (success) {
                        this.$message({
                                        type: 'success',
                                        message: '異動成功'
                                        });
                        this.getCodeAll();
                    } else {
                        this.$message({
                                        type: 'danger',
                                        message: '異動失敗，請重試一次'
                                        });
                    }
                } else {
                    this.$message.error('對不起, 請選擇欲複製的參數設定')
                    return false;
                }
            },

            newType() {
                var elements = {
                    status: 'A',
                    optionNo: this.codeList[this.selectedRowIndex].id,
                    codeNo: '',
                    codeName: '',
                    isDelete: false
                };

                if (this.codeList[this.selectedRowIndex].data == null) {
                    var arry1 = [elements];
                    this.codeList[this.selectedRowIndex].data = arry1;
                } else {
                    this.codeList[this.selectedRowIndex].data.push(elements);
                }
            },
            async updateSet() {
                let tData = this.codeList[this.selectedRowIndex];
                let cLen = tData.data.length;
                let found = false;
                for(var i=0; i < cLen && !found; i++ ){
                    if (tData.data[i].status != '') {
                        found = true;
                    }
                }
                if (found) {
                    const {success} = await this.updateCode(tData);

                    if (success) {
                        this.$message({
                                        type: 'success',
                                        message: '異動成功'
                                        });
                        this.getAllSet();
                    } else {
                        this.$message({
                                        type: 'danger',
                                        message: '異動失敗，請重試一次'
                                        });
                    }
                } else {
                    this.$message.error('對不起, 請修改參數設定')
                    return false;
                }
            }
        },

        watch: {
            config(current) {
                this.model = {...current};
            }
        },

        async created() {
            await this.getConfig();
            await this.getMenus();
        }
    }
</script>

<style scoped>

</style>